'use client';

import type { TFunction } from 'i18next';
import { Search } from 'lucide-react';
import type { FilterParams } from '@/lib/search-filter-params';
import type { FilterTier } from '@/lib/search-gating';
import { Button } from '@/components/ui/button';
import { MobilePagination, SaveSearchControl } from './SidebarFooterParts';

export interface SidebarFooterProps {
  onSaveSearch: ((filters: FilterParams) => void) | undefined;
  collectFilters: () => FilterParams;
  savedSearches:
    | { id: number; name: string; filters: FilterParams }[]
    | undefined;
  isCurrentSearchSaved: boolean;
  t: TFunction<'translation', undefined>;
  onLoadSavedSearch: ((id: number) => void) | undefined;
  handleFormSubmit: () => void;
  tier: FilterTier;
  onOffsetChange: ((offset: number) => void) | undefined;
  offset: number;
  totalLimit: number;
  total: number;
}

export function SidebarFooter(props: SidebarFooterProps) {
  const { onSaveSearch, t, handleFormSubmit, tier, onOffsetChange } = props;
  return (
    <div className="p-4 border-t bg-background/95 supports-[backdrop-filter]:bg-background/90 backdrop-blur-xs flex flex-col gap-3 shrink-0">
      <div className="flex items-center gap-2">
        {onSaveSearch ? (
          <SaveSearchControl {...props} onSaveSearch={onSaveSearch} />
        ) : (
          <div className="flex-1" />
        )}
        <Button
          onClick={handleFormSubmit}
          className="flex-1 h-11 lg:h-9 rounded-lg bg-black hover:bg-neutral-800 text-white font-medium gap-1.5 text-sm"
        >
          <Search size={16} />
          {t('search.sidebar.searchButton')}
        </Button>
      </div>

      {/* Pagination & per-page — logged-in users only */}
      {tier !== 'public' && onOffsetChange && (
        <MobilePagination {...props} onOffsetChange={onOffsetChange} />
      )}
    </div>
  );
}
